import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { apiRequest } from "../services/apiService";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Container } from "react-bootstrap";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("getpossibilities", "GET");
        if (Array.isArray(response)) {
          setOptions(response);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  const groupedOptions = options.reduce((acc, item) => {
    if (!acc[item.groupname]) {
      acc[item.groupname] = [];
    }
    acc[item.groupname].push(item);
    return acc;
  }, {});

  return (
    <div
      style={{
        scrollBehavior: "smooth",
        backgroundColor: "#fafafa",
        padding: "0px 0",
      }}
    >
      <VN userData={userData} />

      <Container>
        <Box sx={{ mb: 5, textAlign: { xs: "center", sm: "left" } }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontWeight: 700, color: "#1a237e", mb: 1 }}
          >
            Usługi w ramach opieki
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Przeglądaj pełen zakres certyfikowanych czynności, które mogą
            realizować nasze opiekunki.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "column",
            columnCount: { xs: 1, md: 1 },
            columnGap: "32px",
          }}
        >
          {Object.entries(groupedOptions).map(([groupName, items]) => (
            <Card>
              <CardContent>
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{
                    marginBottom: 2,
                    fontWeight: 600,
                    color: "#2c3e50",
                    borderBottom: "2px solid #e8f5e9",
                    pb: 1,
                  }}
                >
                  {groupName}
                </Typography>
                <List disablePadding>
                  {items.map((item) => (
                    <ListItem
                      key={item.id}
                      disablePadding
                      sx={{
                        padding: "8px 12px",
                        borderRadius: "8px",
                        marginBottom: "4px",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "#e8f5e9",
                          transform: "translateX(4px)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: "36px" }}>
                        <TaskAltIcon sx={{ color: "#2e7d32", fontSize: 22 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.activity}
                        primaryTypographyProps={{
                          variant: "body1",
                          sx: { color: "#455a64", fontWeight: 500 },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </div>
  );
}
